import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import {list} from "Utils/Reflection";
import * as Topics from "Data/Topics";

import {ch1_p06} from "../../../layouts/ch1_p06/ch1_p06";
import { changeParent } from "Utils/layoutUtils";

export class Chapter1Page6 extends AbstractStoryState {

	readonly board = this.addChild(new SceneSprite());
	readonly stickers = this.addChild(new SceneSprite());
	readonly papers =  this.addChild(new SceneSprite());
	readonly cal = this.addChild(new SceneSprite());
	readonly circle = this.addChild(new SceneSprite());
	readonly cake = this.addChild(new SceneSprite());
	readonly calCord = this.addChild(new SceneSprite());
	readonly calPin = this.addChild(new SceneSprite());
	readonly frame = this.addChild(SceneSprite.withPrefix("ch1_p06/"));
	readonly frameCorner = this.addChild(new SceneSprite());

    public init(pSize: PIXI.Point, pData: any) {
		// exported layout from Animate CC
		ch1_p06.call(this);

		// interaction
		this.circle.interactive = true;
		this.circle.buttonMode = true;
		this.circle.accessible = true;
		this.circle.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
			this.gotoNextState({transition: "left"});
		});

		changeParent(this.cake, this.circle);

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public animateIn(pOnComplete: ()=>void) {
		super.animateIn(pOnComplete);
	}

	protected onAnimateInComplete() {
		super.onAnimateInComplete();
		this.showHint(this.circle);
	}
}